const areAllRoomsSelected = (selectedRoomIds: string[], roomIds: string[]): boolean =>
  roomIds.length > 0 && roomIds.every(id => selectedRoomIds.includes(id));

const toggleAllRooms = (selectedRoomIds: string[], roomIds: string[]): string[] =>
  areAllRoomsSelected(selectedRoomIds, roomIds)
    ? selectedRoomIds.filter(id => !roomIds.includes(id))
    : [...new Set([...selectedRoomIds, ...roomIds])];

export { areAllRoomsSelected, toggleAllRooms };
